import { INCIDENCE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'

export const incidenceTrackingBlocked = (incidenceName: string) => {
  const BLOCKED_INCIDENCES = [
    INCIDENCE_TYPES.contract,
    INCIDENCE_TYPES.sick,
    INCIDENCE_TYPES.parental,
    INCIDENCE_TYPES.hiring,
    INCIDENCE_TYPES.termination,
  ]

  return BLOCKED_INCIDENCES.includes(incidenceName)
}
